export enum MessageType {
    OperatorMessage = 1,
    ClientMessage,
    SystemMessage,
    ClientSystemMessage
}
